module.exports = __webpack_public_path__ + "img/notoshop.d17be8b9.png";